export default __webpack_public_path__ + "homecookies.jpg";